import { IconButton } from "@chakra-ui/react";

import type { ReactElement } from "react";

interface CustomIconButtonProps {
	icon: ReactElement;
	onClick: () => void;
}

export const CustomIconButton = (props: CustomIconButtonProps) => {
	const { icon, onClick } = props;

	return (
		<IconButton
			size="sm"
			rounded="3"
			icon={icon}
			onClick={onClick}
			color="brand.light"
			transition="background 200ms"
			aria-label="previous testimonial"
			bg={"brand.dark"}
			_hover={{ bg: "brand.contrast" }}
		/>
	);
};
